import About from '../../components/About'
import HeroSection from '../../components/HeroSection'
import HowItWorks from '../../components/HowItWorks'

function Home() {
	return (
		<div>
			<HeroSection />
            <HowItWorks />
			<About />
		</div>
	)
}

export default Home
